import BlockDiagram from './BlockDiagram'
export default BlockDiagram
